import React from 'react';
import { XCircle } from 'lucide-react';
import './screens.css';

const BillingCancelScreen = ({ goToHome, goToPlan }) => {
  return (
    <div className="billing-result-screen">
      <div className="billing-result-container">
        <div className="billing-result-icon cancel">
          <XCircle size={64} />
        </div>

        <h2 className="billing-result-title">購入がキャンセルされました</h2>

        <p className="billing-result-message">
          お支払い手続きがキャンセルされました。<br />
          もう一度お試しいただくか、後ほどご利用ください。
        </p>

        <div className="billing-result-note info">
          <p>
            💡 プラン購入はいつでも可能です。<br />
            必要なときにプラン画面からご購入ください。
          </p>
        </div>

        <div className="billing-result-actions">
          <button
            className="billing-result-button primary"
            onClick={goToHome}
          >
            ホームに戻る
          </button>
          <button
            className="billing-result-button secondary"
            onClick={goToPlan}
          >
            プラン画面に戻る
          </button>
        </div>
      </div>
    </div>
  );
};

export default BillingCancelScreen;
